import React, {FunctionComponent} from "react";
import FlexContent, {FlexContentDirection, FlexContentLayout, FlexContentSpacing} from "../flex-content/FlexContent";
import clsx from "clsx";

export type FormLayoutColumnsProps = {
    children: React.ReactNode;
    columns?: 2 | 3 | 4;
    layout?: FlexContentLayout.TWO_COLUMNS_WIDE_LEFT | FlexContentLayout.TWO_COLUMNS_WIDE_RIGHT;
    cssClass?: string;
};

const FormLayoutColumns: FunctionComponent<FormLayoutColumnsProps> = ({children, columns, layout = FlexContentLayout.COLUMNS, cssClass}) => {
    let childrenList = (Array.isArray(children) ? children : [children]).filter((it) => !!it);

    if (!childrenList.length) {
        return <></>;
    }

    if (columns && childrenList.length > columns) {
        childrenList = childrenList.slice(0, columns);
    }

    return (
        <FlexContent
            direction={FlexContentDirection.ROW}
            layout={layout}
            spacing={FlexContentSpacing.LARGE}
            cssClass={clsx("form-layout__columns", cssClass)}
        >
            {childrenList}
            {columns && [...Array(Math.max(0, columns - childrenList.length))].map((it, index) =>
                <div key={`column-${index.toString()}`} className={"form-layout__filler"}/>
            )}
        </FlexContent>
    );
};

export default FormLayoutColumns;
